import type { ComponentProps } from 'react'

import { Helmet } from '@dr.pogodin/react-helmet'
import { startCase } from 'lodash-es'
import { connect, currentPage, Obj, urlFor } from 'scrivito'

import { ensureString } from '../utils/ensureString'
import { getMetadata } from '../utils/getMetadata'

type HelmetProps = ComponentProps<typeof Helmet>

export const CurrentPageMetadata = connect(() => {
  const links: HelmetProps['link'] = []
  let meta: HelmetProps['meta'] = []
  let lang = 'en'
  let title = ''

  const root = Obj.root()
  const favicon = root?.get('siteFavicon')
  if (favicon instanceof Obj && favicon.contentType().startsWith('image/')) {
    links.push({
      rel: 'shortcut icon',
      type: favicon.contentType(),
      href: urlFor(favicon),
    })
  }

  const page = currentPage()

  if (page) {
    lang = page.language() || 'en'
    title = startCase(ensureString(page.get('title')))
    links.push({ rel: 'canonical', href: urlFor(page) })
    meta = getMetadata(page)
  }

  return (
    <Helmet htmlAttributes={{ lang }} link={links} meta={meta} title={title} />
  )
})
